import $ from 'jquery';
import I18n from 'i18n-js';
import webshim from 'webshim';
import 'cookieconsent';
import './basic';
import './translations';
import './split_test';

/* LOADING LEGACY JS
 *
 * We are using Webpacks exports-loader
 * to fake that that our legacy scripts (all in views/)
 * have proper exports.
 * The map of all the files->faux exports is in legacy_exports.js
 */
/* single export */
import setupActions from './views/actions';
import loadCharts from './views/ajax_loading_chart';
import loadTwitter from './views/follow';
import bindShareClickListener from './views/share_popup';
import setupRActionFacebook from './views/actions/facebook';
import setupRActionTweet from './views/actions/tweet';
import setupEuplatesc from './views/actions/donate/euplatesc';
import bindInfoboxChangeListener from './views/campaigns/build/infobox';
import bindCampaignJourneyChangeListener from './views/campaigns/build/decisions';
import bindCampaignLabelClickListener from './views/campaigns/add_decisions';
import bindCampaignBuilder from './views/campaigns/build';
import bindRecurrentDonationEventListener from './views/others/recurrent_donation';
import bindSortableQuestion from './views/questions/ranking';
import setupQuestionBlocks from './views/surveys/question_blocks';
import setupAndBindDecisionsEvents from './views/threeway/campaigns';

/* many exports */
import socialMedia from './views/social_media';
import iframe from './views/iframe';
import rankingResultsGrid from './views/ranking_results_grid';
import share from './views/share';
import actionsCall from './views/actions/call';
import actionsFax from './views/actions/fax';
import actionsMail from './views/actions/mail';
import actionsSign from './views/actions/sign';
import actionsDonateOneOff from './views/actions/donate/one_off';
import actionsDonatePayu from './views/actions/donate/payu';
import survey from './views/surveys/survey';
import appUtils from './app';
import * as validations from './es6/validations';
import * as payu from './es6/payu';
import * as trackersFbGraphApi from './trackers/facebook_graph_api';
import * as trackersFbPixel from './trackers/facebook_pixel';
import * as trackersGoogleAnalytics from './trackers/google_analytics';
import * as trackersGoogleTagManager from './trackers/google_tag_manager';
import * as trackersAmplitude from './trackers/amplitude';
import * as trackersPiwik from './trackers/piwik';
import * as trackersSnapchatPixel from './trackers/snapchat_pixel';
import * as mail from './es6/mail';

/* no exports */
import './views/alert';

// Globally accessible objects
window.$ = $;
window.I18n = I18n;
window.webshim = webshim;

// Globally accessible social media info
window.socialMediaStatuses = {
  facebook: false,
  twitter: false,
};

// Global jQuery plugins initialize
$(document).ready(() => {
  $('[data-toggle="tooltip"]').tooltip();
});

/* Make legacy exports global like we like */
Object.assign(
  window,
  {
    jQuery: $,
    setupActions,
    loadCharts,
    loadTwitter,
    bindShareClickListener,
    setupRActionFacebook,
    setupRActionTweet,
    setupEuplatesc,
    bindInfoboxChangeListener,
    bindCampaignJourneyChangeListener,
    bindCampaignLabelClickListener,
    bindCampaignBuilder,
    bindRecurrentDonationEventListener,
    bindSortableQuestion,
    setupQuestionBlocks,
    setupAndBindDecisionsEvents,
  },
  socialMedia,
  iframe,
  rankingResultsGrid,
  share,
  actionsCall,
  actionsFax,
  actionsMail,
  actionsSign,
  actionsDonateOneOff,
  actionsDonatePayu,
  survey,
  appUtils,
  validations,
  payu,
  trackersFbGraphApi,
  trackersFbPixel,
  trackersGoogleAnalytics,
  trackersGoogleTagManager,
  trackersAmplitude,
  trackersPiwik,
  trackersSnapchatPixel,
  mail,
);
